// Application mutation imports.
import { APP_IS_LOADING } from 'vx/mutations'

// Application state.
const state = {
  loading: false,
  helpLink: 'https://intercom.help/pickstar-help/en/collections/2830220-client'
}

// Application state getters.
const getters = {}

// Application actions.
const actions = {}

// Application state mutations.
const mutations = {
  [APP_IS_LOADING] (state, loading) {
    state.loading = loading
  }
}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, getters, actions, mutations
}
